export enum UserConsentKeys {
  showGuestsNearbyHotels = 'showGuestsNearbyHotels',
  websiteOptOutTripProfit = 'websiteOptOutTripProfit',
  websiteAllowHotelLinkIntercept = 'websiteAllowHotelLinkIntercept',
  honeymoonLeadGenSurveyCompleted = 'honeymoonLeadGenSurveyCompleted',
  dayOfLeadGenSurveyCompleted = 'dayOfLeadGenSurveyCompleted',
  scheduleOptOutWhereToStayLink = 'scheduleOptOutWhereToStayLink',
}
